import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ContractError, err, ok } from "@nju/result";
import { IFetchPostCodesResult, IParams, IPostCode } from "./types";
import { serverResponse } from "./validators";

export async function fetchPostCodes({
  query,
  signal,
  cityId,
}: IParams): Promise<IFetchPostCodesResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/installations/address/postCodes`,
    {
      signal,
      searchParams: {
        ...(cityId ? { municipalityId: cityId } : {}),
        query,
      },
    },
  );

  if (result.isError) {
    if (result.err.code !== "REQUEST_ABORTED") {
      Bugsnag.notify(result.err);
    }
    return result;
  }

  const postCodes = Array.isArray(result.value)
    ? result.value.splice(0, 20)
    : result.value;

  const validated = serverResponse.safeParse(postCodes);

  if (!validated.success) {
    Bugsnag.notify(validated.error, (event) => {
      event.addMetadata("result", {
        response: result.value,
        municipalityId: cityId,
        query,
      });
    });
    return err(
      new ContractError({
        violations: validated.error,
        extra: {
          where: `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/installations/address/postCodes`,
        },
      }),
    );
  }

  const entries: IPostCode[] = validated.data.map((postCode) => {
    return {
      postCode: postCode.postCode,
    };
  });

  return ok(entries);
}
